<span>
    Displaying
    {{
      (currentPage === 0 && totalItems < pageSize)
        ? totalItems
        : (currentPage === 0 && totalItems >= pageSize)
          ? pageSize
          : (((currentPage - 1) * pageSize + 1) <= totalItems
            ? ((currentPage - 1) * pageSize + 1)
            : (currentPage * pageSize > totalItems ? totalItems - pageSize + 1 : currentPage * pageSize))
    }}
    -
    {{
      (currentPage === 0 && totalItems < pageSize)
        ? totalItems
        : (currentPage === 0 && totalItems >= pageSize)
          ? pageSize
          : (((currentPage - 1) * pageSize + dataLength) <= totalItems
            ? ((currentPage - 1) * pageSize + dataLength)
            : (currentPage * pageSize > totalItems ? totalItems : currentPage * pageSize))
    }}
    of {{ totalItems }} {{ itemName }} {{ isNode ? 'Nodes' : ''}}
  </span>
  